// extracted by mini-css-extract-plugin
export default {"solid":"Statuses_solid__4s7LG","statusWrapper":"Statuses_statusWrapper__0sRXo","withoutLabel":"Statuses_withoutLabel__UPJ5P"};